import {derived} from 'svelte/store';

import {optimizeKarts}         from '../../services/optimize-karts';
import {optimizeStore}         from './optimize-store';
import {results2FilteredStore} from './results-2-filtered-store';

const createStore = () => {
  const {subscribe} = derived(
    [optimizeStore, results2FilteredStore],
    ([$optimizeStore, $results2FilteredStore]) => {
      const karts = $optimizeStore ? optimizeKarts($results2FilteredStore.karts) : $results2FilteredStore.karts;

      return {
        counts: {
          ...$results2FilteredStore.counts,
          optimized: karts.length
        },
        karts,
        maxScores: $results2FilteredStore.maxScores
      }
    }
  );

  return {subscribe};
};

export const results3OptimizedStore = createStore();
